import { Stack, Typography } from "@mui/material";
import React from "react";
import { doc } from "firebase/firestore";
import { db } from "firebaseApp";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { signOut } from "firebase/auth";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import RechargeForm from "components/react-lib/stripe-credit-payments/RechargeForm";
import LabelledOutline from "components/react-lib/generic-ui/LabelledOutline";
import { colors } from "colors";
import Loader from "../react-lib/generic-ui/Loader";
import ChargeAccountSelector from "components/react-lib/stripe-credit-payments/ChargeAccountSelector";
import ReduxModal from "components/react-lib/generic-ui/modals/ReduxModal";
import { useTheme } from "@emotion/react";

export default function CreditAccountsModal() {
  const theme = useTheme();
  const auth = useAuth();
  const uid = auth.currentUser?.uid;

  const [profile, loadingProfile, profileError] = useDocumentData(
    doc(db, "userPublicProfiles", uid)
  );

  if (profileError) {
    console.log(profileError);
  }

  const renderContent = () => {
    return (
      <Stack spacing={2}>
        {loadingProfile || !profile ? (
          <Loader message="Loding profile" progressProps={{
            color: "secondary",
          }} />
        ) : (
          <Stack spacing={2} pt={1}>
            <LabelledOutline
              label="Select active credit account"
              rawLabelColor={theme.palette.formLabel.main}
            >
                <ChargeAccountSelector 
                  uid={uid} 
                  color="secondary"
                  loaderProps={{
                    progressProps: {
                      color: "secondary",
                    }
                  }}
                />
            </LabelledOutline>
            <LabelledOutline
              label={"Add credits to a credit account"}
              rawLabelColor={theme.palette.formLabel.main}
            >
              <RechargeForm
                uid={uid}
                headerText=""
                amountButtonColor="secondary"
                rechargeButtonColor="secondary"
                renderLoader={() => (
                  <Loader
                    message="Loading"
                    progressProps={{
                      color: "secondary",
                    }}
                  />
                )}
                selectorProps={{
                  color: "secondary",
                }}
                loaderProps={{
                  progressProps: {
                    color: "secondary",
                  }
                }}
              />
            </LabelledOutline>
          </Stack>
        )}
      </Stack>
    );
  };

  return (
    <ReduxModal
      fullWidth
      maxWidth="sm"
      name="creditAccounts"
      title="Credit Accounts"
      renderContent={renderContent}
    >
      {renderContent()}
    </ReduxModal>
  );
}
